import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { NavbarComponent } from '../../../../components/navbar/navbar.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { SwitcherComponent } from '../../../../components/switcher/switcher.component';

@Component({
  selector: 'app-user-invoice',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    NavbarComponent,
    FooterComponent,
    SwitcherComponent
  ],
  templateUrl: './user-invoice.component.html',
  styleUrl: './user-invoice.component.scss'
})
export class UserInvoiceComponent {
isModal:Boolean = false

openModal() {
  this.isModal = !this.isModal
 }
}
